import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import defaultImg from "../../../assets/images/users/user-dummy-img.jpg";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetEmployeeAssessmentDetailState, getEmployeeAssessmentDetail as onGetEmployeeAssessmentDetails, addNewEmployeeAssessmentDetail as onAddNewEmployeeAssessmentDetail, updateEmployeeAssessmentDetail as onUpdateEmployeeAssessmentDetail, deleteEmployeeAssessmentDetail as onDeleteEmployeeAssessmentDetail, getEmployeeAssessmentDetailLoading } from "../../../store/employeeAssessmentDetail/action";
import { getEmployeeAssessment as onGetEmployeeAssessments, addNewEmployeeAssessment as onAddNewEmployeeAssessment, updateEmployeeAssessment as onUpdateEmployeeAssessment, deleteEmployeeAssessment as onDeleteEmployeeAssessment, getEmployeeAssessmentLoading, resetEmployeeAssessmentState } from "../../../store/employeeAssessment/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EmployeeAssessment = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const { employeeAssessments, isEmployeeAssessmentCreated, isEmployeeAssessmentSuccess, loading, error, employeeAssessmentDetails, employeeAssessmentDetailLoading, isEmployeeAssessmentDetailCreated, isEmployeeAssessmentDetailSuccess, employees, employeeLoading } = useSelector((state) => ({
    employeeAssessments: state.EmployeeAssessment.employeeAssessments,
    isEmployeeAssessmentCreated: state.EmployeeAssessment.isEmployeeAssessmentCreated,
    isEmployeeAssessmentSuccess: state.EmployeeAssessment.isEmployeeAssessmentSuccess,
    loading: state.EmployeeAssessment.loading,
    error: state.EmployeeAssessment.error,
    employeeAssessmentDetails: state.EmployeeAssessmentDetail.employeeAssessmentDetails,
    employeeAssessmentDetailLoading: state.EmployeeAssessmentDetail.loading,
    isEmployeeAssessmentDetailCreated: state.EmployeeAssessmentDetail.isEmployeeAssessmentDetailCreated,
    isEmployeeAssessmentDetailSuccess: state.EmployeeAssessmentDetail.isEmployeeAssessmentDetailSuccess,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [employeeAssessmentList, setEmployeeAssessmentList] = useState([]);
  const [employeeAssessment, setEmployeeAssessment] = useState([]);
  const [assessmentDetailAddedId, setAssessmentDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [statusActive, setStatusActive] = useState([]);
  const [employeeAssessmentDetail, setEmployeeAssessmentDetail] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [assignToList, setAssignToList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [employee, setEmployee] = useState(null);
  const [isApprover, setIsApprover] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const ref = useRef(null);


  const onClickDelete = (employeeAssessment) => {
    setEmployeeAssessment(employeeAssessment);
    setDeleteModal(true);
  };

  const handleDeleteEmployeeAssessment = () => {
    if (employeeAssessment) {
      dispatch(onDeleteEmployeeAssessment(employeeAssessment));
      setDeleteModal(false);
    }
  };

  const onClickApprove = (employee) => {
    setEmployeeAssessment(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredEmployeeAssessments = employeeAssessments;
      if (type !== "all") {
        filteredEmployeeAssessments = employeeAssessments.filter((employeeAssessment) => employeeAssessment.kpiea_status.name === type);
      }
      setEmployeeAssessmentList(filteredEmployeeAssessments);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetEmployeeAssessmentState());
      dispatch(onGetEmployeeAssessments({ type: "360" }));
      setIsSearch(true);
    }
  }, [dispatch, employeeAssessments, isSearch]);

  useEffect(() => {
    if (!employee) {
      const emp = JSON.parse(localStorage.getItem("authUser"));
      setEmployee(emp.data);
      if (emp.data && emp.data.employee_user && emp.data.employee_user.user_role) {
        let approver = false;
        for (const element of emp.data.employee_user.user_role) {
          if (element.method === "approveEmployeeAssessment") approver = true;
        }
        setIsApprover(approver);
        dispatch(resetEmployeeState());
        dispatch(getEmployee({ type: "referral", status: 2 }));
      }
    }
  }, [employee, isAdmin, dispatch]);

  useEffect(() => {
    if (!isEmpty(employeeAssessments) && isSearch) {
      setIsEdit(false);
      setEmployeeAssessmentList(employeeAssessments);
      let current = 0;
      if (assessmentDetailAddedId !== 0) {
        employeeAssessments.forEach((obj, i) => {
          if (obj.id === assessmentDetailAddedId) current = i;
        });
      }
      setInfo(employeeAssessments[current]);
    }
  }, [employeeAssessments, assessmentDetailAddedId, isSearch]);

  useEffect(() => {
    if (isEmployeeAssessmentDetailCreated) {
      dispatch(resetEmployeeAssessmentDetailState());
      dispatch(resetEmployeeAssessmentState());
      dispatch(onGetEmployeeAssessments({ type: "360" }));
    }
  }, [dispatch, isEmployeeAssessmentDetailCreated]);

  useEffect(() => {
    if (!isEmpty(employees)) {
      var data = [];
      var opt = [];
      employees.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const companyId = item.companyId;
        const positionId = item.positionId;
        const position_name = item.employee_position && item.employee_position.name ? item.employee_position.name : "Not set";
        var obj = { label: name + " - " + position_name, value: id, companyId: companyId, positionId: positionId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setEmployeeList(data);
      setAssignToList(data);
    }
  }, [employees]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setEmployeeAssessment(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleEmployeeAssessmentClick = useCallback((arg) => {
    const data = arg;
    let kpiea_assign = [];
    if (data.kpiea_assign && data.kpiea_assign.length) {
      data.kpiea_assign.forEach((item) => {
        const name = item.kpiassign_employee.name;
        const id = item.employeeId;
        var obj = { label: name, value: id };
        kpiea_assign.push(obj);
      });
    }

    setEmployeeAssessment({
      id: data.id,
      assignto: kpiea_assign,
      assessmentat: data.startat + " to " + data.endat,
      percentage: data.percentage,
      company: { label: data.kpiea_company.name, value: data.kpiea_company.id },
      employee: { label: data.kpiea_employee.name, value: data.kpiea_employee.id, companyId: data.kpiea_employee.companyId, positionId: data.kpiea_position.id },
    });

    setIsEdit(true);
    toggle();
  }, [toggle]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setEmployeeAssessmentDetail(null);
      setEmployeeAssessment(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleEmployeeAssessmentDetailClick = useCallback((arg, arginfo, isEdit) => {
    const data = arg;

    setEmployeeAssessmentDetail({
      id: data.id,
      perspective: data.perspective,
      target: data.target,
      indicator: data.indicator,
      percentage: data.percentage,
      assessor_description: data.assessor_description,
      assessor_score: data.assessor_score,
      realization: data.realization,
      realization_description: data.realization_description,
      assessmentId: data.assessmentId,
      isTraining: data.isTraining,
      score: data.kpiead_pp && { label: data.kpiead_pp.name, value: data.kpiead_pp.id },
    });

    setIsEditDetail(isEdit);
    toggleDetail();
  }, [toggleDetail]);

  const columns = useMemo(
    () => [
      {
        Header: "Employee",
        accessor: "kpiea_employee.name",
        filterable: true,
      },
      {
        Header: "Period",
        accessor: "startat",
        filterable: true,
        Cell: (data) => <>{handleValidDate(data.row.original.startat)}</>,
      },
      {
        Header: "Assigned To",
        accessor: "kpiea_assign",
        filterable: false,
        Cell: (cell) => {
          const assigned = cell.value.map((item) => (item.kpiassign_employee && item.kpiassign_employee ? item.kpiassign_employee : item));
          return (
            <React.Fragment>
              <div className="avatar-group">
                {assigned.map((item, index) => (
                  <Link key={item.id + "-assigned"} to="#" className="avatar-group-item">
                    {item.employee_image && item.employee_image.path ? (
                      <img id={"image" + item.id + "-assigned"} src={process.env.REACT_APP_API_URL + "/files/" + item.employee_image.path} alt="" className="rounded-circle avatar-xs" />
                    ) : (
                      <div id={"image" + item.id + "-assigned"} className="flex-shrink-0 avatar-xs">
                        <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item.name.charAt(0)}</div>
                      </div>
                    )}
                    <UncontrolledTooltip placement="top" target={"image" + item.id + "-assigned"}>
                      {item.name}
                    </UncontrolledTooltip>
                  </Link>
                ))}
              </div>
            </React.Fragment>
          );
        },
      },
      {
        Header: "Average Value",
        filterable: true,
        Cell: (data) => <>{data.row.original.total_asessor}</>,
      },
      {
        Header: "Status",
        accessor: "kpiea_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              {cellProps.row.original.statusId === 10 ? (
                <button
                  className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
                  onClick={() => {
                    let data = cellProps.row.original;
                    onClickApprove(data);
                  }}>
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>Approve
                </button>
              ) : (
                ""
              )}
              <Link
                to="#"
                className="btn-icon btn btn-sm btn-light"
                onClick={() => {
                  setInfo(cellProps.row.original);
                  ref.current?.scrollIntoView({ behavior: "smooth" });
                }}>
                <i className="ri-eye-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className="btn-icon btn btn-sm btn-light edit-item-btn"
                onClick={() => {
                  handleEmployeeAssessmentClick(cellProps.row.original);
                }}>
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                onClick={() => {
                  const employeeAssessmentData = cellProps.row.original;
                  onClickDelete(employeeAssessmentData);
                }}>
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
    ], [handleEmployeeAssessmentClick]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: employeeAssessmentList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  const handleApproveAssessment = () => {
    if (employeeAssessment) {
      employeeAssessment.setApprove = true;
      dispatch(onUpdateEmployeeAssessment(employeeAssessment));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      assessmentat: employeeAssessment && employeeAssessment.assessmentat,
      employee: employeeAssessment && employeeAssessment.employee,
      assignto: employeeAssessment && employeeAssessment.assignto,
    },
    validationSchema: Yup.object({
      assessmentat: Yup.string().required("Please Enter Assessment Date").nullable(true),
      employee: Yup.object().required("Please Enter Employee").nullable(true),
    }),
    onSubmit: (values) => {
      let datearr = values.assessmentat.split(" to ");
      let startat = datearr[0] && datearr[0];
      let endat = datearr[1] ? datearr[1] : datearr[0] && datearr[0];

      dispatch(getEmployeeAssessmentLoading());
      if (isEdit) {
        const updateEmployeeAssessment = {
          id: employeeAssessment ? employeeAssessment.id : 0,
          startat: startat,
          endat: endat,
          employeeId: values.employee.value,
          positionId: values.employee.positionId,
          type: "360",
          companyId: values.employee.companyId,
          assignto: values.assignto,
          statusId: 2,
        };
        dispatch(onUpdateEmployeeAssessment(updateEmployeeAssessment));
        validation.resetForm();
      } else {
        const newEmployeeAssessment = {
          startat: startat,
          endat: endat,
          type: "360",
          employeeId: values.employee.value,
          positionId: values.employee.positionId,
          companyId: values.employee.companyId,
          assignto: values.assignto,
          statusId: 2,
        };
        dispatch(onAddNewEmployeeAssessment(newEmployeeAssessment));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    enableReinitialize: true,
    initialValues: {
      assessmentId: (employeeAssessmentDetail && employeeAssessmentDetail.assessmentId) || (info && info.id),
      employeeId: info && info.employeeId,
      assessor_score: (employeeAssessmentDetail && employeeAssessmentDetail.assessor_score) || 0,
      assessor_description: (employeeAssessmentDetail && employeeAssessmentDetail.assessor_description) ?? "",
      realization_description: (employeeAssessmentDetail && employeeAssessmentDetail.realization_description) ?? "",
      realization: (employeeAssessmentDetail && employeeAssessmentDetail.realization) || 0,
      isTraining: (employeeAssessmentDetail && employeeAssessmentDetail.isTraining) || false,
    },
    validationSchema: Yup.object({
      assessor_description: Yup.string().required("Please Enter Feedback").nullable(true),
      assessor_score: Yup.number().required("Please Enter Realization Percentage").nullable(true),
    }),
    onSubmit: (values) => {
      setAssessmentDetailAddedId(values.assessmentId);
      dispatch(getEmployeeAssessmentDetailLoading());
      const updateEmployeeAssessmentDetail = {
        id: employeeAssessmentDetail ? employeeAssessmentDetail.id : 0,
        assessmentId: values.assessmentId,
        employeeId: values.employeeId,
        assessor_score: values.assessor_score,
        assessor_description: values.assessor_description,
        type: "360",
        realization: values.realization,
        realization_description: values.realization_description,
      };
      dispatch(onUpdateEmployeeAssessmentDetail(updateEmployeeAssessmentDetail));
      validationDetail.resetForm();
      toggleDetail();
    },
  });

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteEmployeeAssessmentDetail(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    dispatch(resetEmployeeAssessmentState());
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      type: "360",
    };
    dispatch(onGetEmployeeAssessments(param));
  }

  document.title = "Assessment Guideline | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ApproveModal data={employeeAssessment && employeeAssessment.kpiea_employee ? employeeAssessment.kpiea_employee.name : ""} show={approveModal} onApproveClick={handleApproveAssessment} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteEmployeeAssessment} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="360 Feedback" pageTitle="Human Resources" />
        <Row>
          <Col xxl={7}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    360 Feedback History&nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className="btn btn-primary add-btn me-2"
                      id="create-btn"
                      onClick={() => {
                        setEmployeeAssessment(null);
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className=" ri-star-line me-1 align-bottom fs-14"></i> Tambah
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#">
                        <i className=" ri-star-line me-1 align-bottom fs-14"></i> All
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#">
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1} className="col-xxl-3">
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""} />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col className="col-xxl-4">
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">
                      {rows.length} Data
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Page
                      <strong>

                        {pageIndex + 1} of {pageOptions.length}
                      </strong>
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Assessment" : "Add Assessment"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="employee" className="form-label">
                            Employee
                            {employeeLoading ? (
                              <Spinner color="primary" size="sm">

                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </Label>
                          <Select
                            name="employee"
                            value={validation.values.employee}
                            isDisabled={!isApprover}
                            placeholder="Enter Employee"
                            onChange={(e) => {
                              validation.setFieldValue("employee", e);
                            }}
                            options={employeeList}
                            noOptionsMessage={(e) => "Type Employee to get option"}
                            invalid={validation.touched.employee && validation.errors.employee ? true : false}></Select>
                          {validation.touched.employee && validation.errors.employee ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.employee}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="assignto" className="form-label">
                            Assign Assessor
                            {employeeLoading ? (
                              <Spinner color="primary" size="sm">

                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </Label>
                          <Select
                            name="assignto"
                            value={validation.values.assignto}
                            placeholder="Enter Assessor"
                            isMulti
                            onChange={(opt, { option }) => {
                              let newOpts = opt;
                              if (option && option.value === "all") {
                                let filteredOptions = clone(assignToList);
                                filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                              }
                              validation.setFieldValue("assignto", newOpts);
                            }}
                            options={assignToList}
                            noOptionsMessage={(e) => "Type Employee to get option"}
                            invalid={validation.touched.assignto && validation.errors.assignto ? true : false}></Select>
                          {validation.touched.assignto && validation.errors.assignto ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.assignto}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="assessmentat-field" className="form-label">
                            Assessment Period
                          </Label>
                          <Flatpickr
                            name="assessmentat"
                            className="form-control"
                            id="assessmentat"
                            placeholder="Select Assessment Range Date"
                            value={validation.values.assessmentat}
                            options={{
                              mode: "range",
                              dateFormat: "Y/m/d",
                            }}
                            onChange={(obj, str) => {
                              validation.setFieldValue("assessmentat", str);
                            }} />
                          {validation.touched.assessmentat && validation.errors.assessmentat ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.assessmentat}
                            </small>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}>
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add Assessment"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail ? "Edit Feedback" : "Add Feedback"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="mb-4 fs-14">
                        <h5 className="text-success">
                          {employeeAssessmentDetail && employeeAssessmentDetail.perspective}, {employeeAssessmentDetail && employeeAssessmentDetail.target}
                        </h5>
                        <p className="text-muted">{employeeAssessmentDetail && employeeAssessmentDetail.indicator}</p>
                      </div>
                      <div className="row">
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="assessor_score-field" className="form-label">

                            % Realization
                          </Label>
                          <Input
                            name="assessor_score"
                            id="assessor_score-field"
                            max={100}
                            className="form-control"
                            placeholder="Enter Realization"
                            type="number"
                            onChange={(e) => {
                              Number(e.target.value) > 100 ? validationDetail.setFieldValue("assessor_score", 100) : validationDetail.setFieldValue("assessor_score", Number(e.target.value));
                            }}
                            onBlur={validationDetail.handleBlur}
                            value={validationDetail.values.assessor_score}
                            invalid={validationDetail.touched.assessor_score && validationDetail.errors.assessor_score ? true : false} />
                          {validationDetail.touched.assessor_score && validationDetail.errors.assessor_score ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.assessor_score}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="assessor_description-field" className="form-label">
                            Your Feedback
                          </Label>
                          <Input name="assessor_description" id="assessor_description-field" rows="6" className="form-control" placeholder="Description" type="textarea" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.assessor_description} invalid={validationDetail.touched.assessor_description && validationDetail.errors.assessor_description ? true : false} />
                          {validationDetail.touched.assessor_description && validationDetail.errors.assessor_description ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.assessor_description}
                            </small>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}>
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEditDetail ? "Update Feedback" : "Add Feedback"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
          <Col xxl={5}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">{info.startat && info.kpiea_employee ? info.kpiea_employee.name + " - " + handleValidDate(info.startat) + " to " + handleValidDate(info.endat) : " - "}</h5>
              </div>
              <div className="card-body" ref={ref}>
                {/* <Grid
                  data={info.kpiea_detail || []}
                  columns={[
                    {
                      name: _(<span className="text-muted">Performance Appraisal Description</span>),
                      id: 'Performance Appraisal Description',
                      width: '58%',
                      data: (row) => row,
                      formatter: (cell) => _(<div>
                        <p className="fw-semibold mb-2 text-success">{cell.perspective}</p>
                        <p className="fw-semibold mb-1">{cell.target}</p>
                        <p className="mb-3">{cell.description}</p>
                        <p className="fw-semibold mb-1">Indicator, Measures and Target</p>
                        <p className="mb-3">{cell.indicator}</p>

                        <button className="btn-label btn btn-sm btn-success fs-13 me-0"
                          onClick={() => {
                            handleEmployeeAssessmentDetailClick(cell, info, true);
                          }}>
                          <i className="ri-pencil-line label-icon align-middle me-0"></i> Feedback
                        </button>
                      </div>)
                    }]}
    Search={false}
                  fixedHeader={true}
                  height={'600px'}
                  sort={true} /> */}
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EmployeeAssessment;
